var angular = require('angular');
var _module = angular.module('benoit');
var _ = require('lodash');
var simpleCypher = require('../../../libs/simple-cypher');

require('./_styles.scss');
require('../../services/user');
require('../../services/search-results-utils');
require('../../services/verify-modal');
require('../../services/activity-feed');
require('../../services/lr-touch');
require('../../services/listing');

_module.controller('FavoriteBtnCtrl', [
    '$scope',
    '$log',
    '$user',
    '$loginOrRegisterModal',
    '$verifyModal',
    '$activityFeed',
    'Listing',
    '$analytics',

    function FavoriteBtnCtrl($scope, $log, $user, $loginOrRegisterModal, $verifyModal, $activityFeed, Listing, $analytics) {
        $log.debug('FavoriteBtnCtrl', this);

        var vm = this;
        vm.model = {
            hide: false,
            isFavorite: false,
            favoriteId: undefined,
            decodedListingId: undefined,
            decodedListingSource: undefined
        };
        vm.events = {
            onToggleFavorite: toggleFavorite
        };

        // Functions
        function toggleFavorite() {
            if (verifiedUserCheck()) {
                if (String(vm.model.isFavorite) === 'true') {
                    unfavoriteListing(vm.model.favoriteId);
                } else {
                    favoriteListing();
                }
            } else {
                $log.debug('verifiedUserCheck failed');
            }
        }

        function favoriteListing() {
            vm.model.isFavorite = true;

            var listingData = _.extend({}, vm.listing);
            var postBody = {
                listing_id: vm.listing.id,
                listing_source: vm.model.decodedListingSource,
                listing: listingData
            };

            $log.debug('Trying to favorite: ', postBody);

            if (vm.searchFilterId) {
                postBody.searchFilterId = vm.searchFilterId;
            }

            $user
                .addFavorite(postBody)
                .then(function (response) {
                    $log.debug('Added Favorite!', response);

                    vm.model.isFavorite = true;
                    vm.model.favoriteId = response.data.id;
                    vm.onToggle({ $value: true });

                    var eventMeta = {
                        benoitPartnerId: $user.affiliate.benoitPartnerId,
                        benoitUserId: $user.id,
                        name: $user.full_name,
                        first_name: $user.first_name,
                        last_name: $user.last_name,
                        address: vm.listing.address,
                        listingId: vm.model.decodedListingId,
                        listing_source: vm.model.decodedListingSource,
                    };

                    if (vm.searchFilterId) {
                        eventMeta.filterId = vm.searchFilterId;
                    }

                    $activityFeed.add({
                        avatar: 'initials',
                        type: 'lead',
                        name: 'benoit_listing_favorited_by_user',
                        userId: $user.affiliateId,
                        meta: eventMeta
                    });

                    var eventData = _.extend(eventMeta, {
                        'Source': 'Add'
                    });

                    $analytics.eventTrack('Nest Favorite Icon Click', eventData);

                })
                .catch(function (err) {
                    $log.error('Error trying to favorite listing', err);
                    vm.model.isFavorite = false;
                });
        }

        function unfavoriteListing(id) {
            if (id) {
                vm.model.isFavorite = false;

                $user
                    .removeFavorite(id)
                    .then(function (response) {
                        $log.debug('Removed Favorite!', response);

                        vm.model.isFavorite = false;
                        vm.model.favoriteId = null;
                        vm.onToggle({ $value: false });

                        var eventMeta = {
                            benoitPartnerId: $user.affiliate.benoitPartnerId,
                            benoitUserId: $user.id,
                            name: $user.full_name,
                            first_name: $user.first_name,
                            last_name: $user.last_name,
                            address: vm.listing.address,
                            listingId: vm.model.decodedListingId,
                            listing_source: vm.model.decodedListingSource,
                            filterId: vm.model.searchFilterId
                        };

                        if (vm.searchFilterId) {
                            eventMeta.filterId = vm.searchFilterId;
                        }

                        $activityFeed.add({
                            avatar: 'initials',
                            type: 'lead',
                            name: 'benoit_listing_unfavorited_by_user',
                            userId: $user.affiliateId,
                            meta: eventMeta
                        });

                        var eventData = _.extend(eventMeta, {
                            'Source': 'Remove'
                        });
    
                        $analytics.eventTrack('Nest Favorite Icon Click', eventData);

                    })
                    .catch(function (err) {
                        $log.error('Error trying to favorite listing', err);
                        vm.model.isFavorite = true;
                    });
            }
        }

        function verifiedUserCheck() {
            if (_.get($user, 'account_type', false)) {
                switch ($user.account_type.toLowerCase()) {
                    case 'verified':
                        return true;

                    case 'unverified':
                        $verifyModal();
                        return false;

                    case 'guest':
                    default:
                        $loginOrRegisterModal();
                        return false;
                }
            } else {
                $loginOrRegisterModal();
                return false;
            }
        }

        function favoriteCheck() {
            var favorites = $user.favorites || [];
            if (!favorites.length) return;

            var query = {
                listing_id: vm.listing.id
            };

            if (vm.searchFilterId) {
                query.searchFilterId = vm.searchFilterId;
            }

            var favorite = _.find(favorites, query);

            if (favorite) {
                vm.model.isFavorite = true;
                vm.model.favoriteId = favorite.id;
            }

            vm.onToggle({ $value: vm.model.isFavorite });
        }

        function init() {

            if (!vm.listing) {
                $log.error('FavoriteBtnCtrl -> getListing Error');
                vm.model.hide = true;
            }

            var decoded = simpleCypher.decode(vm.listing.id);
            if (decoded) {
                vm.model.decodedListingId = decoded.id;
                vm.model.decodedListingSource = decoded.source;
            }
        }

        $scope.$watch(function (scope) { return $user.favorites; }, function (oldVal, newVal) {
            favoriteCheck();
        });
        // init
        init();
    }
]);

_module.component('favoriteBtn', {
    controller: 'FavoriteBtnCtrl',
    controllerAs: 'vm',
    template: require('./index.html'),
    bindings: {
        listing: '<',
        searchFilterId: '@',
        onToggle: '&'
    }
});
